<script setup>
defineProps({
  isActive: {
    type: Boolean,
    required: true,
  },
})
</script>
<template>
  <div
    v-if="isActive"
    class="absolute top-8 -left-9 hidden h-5 -rotate-90 transform items-center rounded-tr rounded-tl bg-secondary px-4 text-xs font-medium text-white md:flex"
  >
    Actief
  </div>
  <div
    v-else
    class="absolute top-8 -left-10 hidden h-5 -rotate-90 transform items-center rounded-tr rounded-tl bg-primary px-4 text-xs font-medium text-white md:flex"
  >
    Inactief
  </div>
</template>
